import React from 'react';
import { object } from 'prop-types';
import { formatCurrency, formatDate, generateSequentialArray } from '@ajaibid/utils';
import { SkeletonLoading } from '@ajaibid/components';

import { styDetail } from './style';
import useHistoryRegularDetail from '../hooks/useHistoryRegularDetail';

function Loading() {
  return (
    <section className={styDetail}>
      {/* 3 Section */}
      {generateSequentialArray(3).map(() => (
        <div>
          {/* 2 Row */}
          {generateSequentialArray(2).map(() => (
            <div>
              <span>
                <SkeletonLoading height={20} width={60} />
              </span>
              <span>
                <SkeletonLoading height={20} width={140} />
              </span>
            </div>
          ))}
        </div>
      ))}
    </section>
  );
}

/**
 * @param {object}  DetailProps
 * @param {import('@services/api/stock/history/regular').HistoryRegular}  DetailProps.item
 */
function Detail({ item }) {
  const { idx_trade_no: idxTradeNo, trade_date: tradeDate } = item;
  const startDate = formatDate(tradeDate, 'YYYY-MM-DD');

  const { data, isLoading } = useHistoryRegularDetail({ idxTradeNo, startDate });

  if (isLoading) {
    return <Loading />;
  }

  const detail = { ...item, ...data?.result };

  const formattedPeriod =
    (detail.period === 'day' && 'Hari') || (detail.period === 'session' && 'Sesi') || '-';

  return (
    <section className={styDetail}>
      <div>
        <div>
          <span>IDX order </span>
          <span>{detail.idx_order_no}</span>
        </div>
        <div>
          <span>Periode</span>
          <span>{formattedPeriod}</span>
        </div>
      </div>
      <div>
        <div>
          <span>Detail Time</span>
          <span>{formatDate(detail.trade_date, 'DD MMM YYYY HH:mm')}</span>
        </div>
        <div>
          <span>Lot Done</span>
          <span>{detail.lot}</span>
        </div>
      </div>
      <div>
        <div>
          <span>Fee</span>
          <span>{detail.fee === null ? '-' : formatCurrency(detail.fee, 'IDR')}</span>
        </div>
      </div>
    </section>
  );
}

Detail.propTypes = {
  item: object.isRequired,
};

export default Detail;
